import { useState } from 'react';

import { styled, TextField, Typography } from '@mui/material';
import { unparse } from 'papaparse';
import { Trans, useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import { blankStudent } from '../constants/inviteStudentsDefaults';
import InviteStudentsContainer from '../InviteStudentsContainer';
import { findDuplicateEmailIndexes, findDuplicateExtUserIdIndexes, validateStudentInvitations } from '../utils/inviteStudentsValidation';
import parseStudentsCsv from '../utils/parseStudentsCsv';

const StyledTextField = styled(TextField)`
    width: 100%;
    margin-bottom: 8px;
` as typeof TextField;

const ItalicTypography = styled(Typography)`
    font-style: italic;
` as typeof Typography;

const dataToCsv = (value: any[]) => unparse(value, { skipEmptyLines: 'greedy', header: false, delimiter: ', ' });

const AdvancedInvite = () => {
    const { t } = useTranslation('invite_students');
    const { students, setStudents, setErrorIndexes, setDuplicateEmailIndexes, setDuplicateExtUserIdIndexes, setAlerts, validationErrorAlert } =
        useContainer(InviteStudentsContainer);

    let initialCsvStudents = dataToCsv(students);
    if (initialCsvStudents === dataToCsv([blankStudent])) {
        initialCsvStudents = '';
    }
    const [csvStudents, setCsvStudents] = useState(initialCsvStudents);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setCsvStudents(event.target.value);
    };

    // set global `students` from csv
    const handleBlur = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const studentsCsvToJson = parseStudentsCsv(event.target.value);
        setStudents(studentsCsvToJson);
        setCsvStudents(dataToCsv(studentsCsvToJson));

        const newErrorIndexes = validateStudentInvitations(studentsCsvToJson);
        setErrorIndexes(newErrorIndexes);

        setDuplicateEmailIndexes(findDuplicateEmailIndexes(studentsCsvToJson));
        setDuplicateExtUserIdIndexes(findDuplicateExtUserIdIndexes(studentsCsvToJson));
        if (newErrorIndexes.length > 0) {
            setAlerts((alerts) => [...alerts, validationErrorAlert]);
        }
    };

    return (
        <>
            <Typography>{t('advanced-mode.instructions.part-one')}</Typography>
            <Trans t={t} i18nKey="advanced-mode.instructions.part-two" />
            <ItalicTypography>{t('advanced-mode.instructions.example-1')}</ItalicTypography>
            <ItalicTypography>{t('advanced-mode.instructions.example-2')}</ItalicTypography>
            <ItalicTypography>{t('advanced-mode.instructions.example-3')}</ItalicTypography>

            <StyledTextField
                placeholder={t('advanced-mode.place-holder')}
                variant="outlined"
                multiline
                rows={10}
                onBlur={handleBlur}
                onChange={handleChange}
                value={csvStudents}
            />
        </>
    );
};

export default AdvancedInvite;
